export interface AirshowExactExportOrderAttestation {
  instance_evidence: "instance_evidence.json#exportOrderAttestation";
  revision: string;
  exact_export_sha256: string;
  helper_build_attestation_revision: string;
  helper_build_fingerprint_sha256: string;
}

const ATTESTATION_KEYS = [
  "exact_export_sha256",
  "helper_build_attestation_revision",
  "helper_build_fingerprint_sha256",
  "instance_evidence",
  "revision",
] as const;

function sha256Revision(value: unknown, path: string): string {
  if (typeof value !== "string" || !/^sha256:[a-f0-9]{64}$/.test(value)) {
    throw new Error(`${path} must be sha256: followed by 64 lowercase hex characters`);
  }
  return value;
}

export function parseAirshowExactExportOrderAttestation(
  value: unknown,
): AirshowExactExportOrderAttestation | null {
  if (value === null || value === undefined) return null;
  if (!value || typeof value !== "object" || Array.isArray(value)) {
    throw new Error("review.loom.export_order_attestation must be an object or null");
  }
  const source = value as Record<string, unknown>;
  const keys = Object.keys(source).sort();
  if (keys.length !== ATTESTATION_KEYS.length
      || keys.some((key, index) => key !== ATTESTATION_KEYS[index])) {
    throw new Error("review.loom.export_order_attestation has unsupported fields");
  }
  if (source.instance_evidence !== "instance_evidence.json#exportOrderAttestation") {
    throw new Error("review.loom.export_order_attestation.instance_evidence is unsupported");
  }
  return {
    instance_evidence: "instance_evidence.json#exportOrderAttestation",
    revision: sha256Revision(source.revision, "review.loom.export_order_attestation.revision"),
    exact_export_sha256: sha256Revision(
      source.exact_export_sha256,
      "review.loom.export_order_attestation.exact_export_sha256",
    ),
    helper_build_attestation_revision: sha256Revision(
      source.helper_build_attestation_revision,
      "review.loom.export_order_attestation.helper_build_attestation_revision",
    ),
    helper_build_fingerprint_sha256: sha256Revision(
      source.helper_build_fingerprint_sha256,
      "review.loom.export_order_attestation.helper_build_fingerprint_sha256",
    ),
  };
}

export function parseAirshowBundleKey(value: unknown): string {
  if (typeof value !== "string" || value.trim() === "") {
    throw new Error("review.loom.bundle_key must be a non-empty string");
  }
  if (!/^[a-f0-9]{64}$/.test(value)) {
    throw new Error("review.loom.bundle_key must be 64 lowercase hex characters");
  }
  return value;
}
